import { Flex, Text } from "shared/components/Spor";
import {
  eventIsInfrastructureEvent,
  eventIsTrainEvent,
} from "features/History/utils/utils";
import { FC } from "react";
import { InfrastructureIncidentIcon18 } from "shared/icons/InfrastructureIncidentIcon18";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { TrainFill18Icon, WarningFill18Icon } from "@vygruppen/spor-icon-react";
import { format } from "date-fns";

type MeasureCardHeaderLabelProps = {
  information: CombinedHistoryResponse;
};

export const MeasureCardHeaderLabel: FC<MeasureCardHeaderLabelProps> = ({
  information,
}) => {
  if (eventIsInfrastructureEvent(information)) {
    return (
      <Flex alignItems="center" gap={1}>
        <InfrastructureIncidentIcon18 />
        <Text variant="sm" fontWeight="bold">
          {information.stretchName}
        </Text>
      </Flex>
    );
  }

  if (eventIsTrainEvent(information)) {
    return (
      <Flex alignItems="center" gap={1}>
        <TrainFill18Icon />
        <Text variant="sm" fontWeight="bold">
          {information.trainIdentifier.identifier}
        </Text>
        {information.lineNumber && (
          <Text variant="sm">{information.lineNumber}</Text>
        )}
        <Text variant="sm">
          ({format(information.trainIdentifier.nominalDate, "dd.MM")})
        </Text>
      </Flex>
    );
  }

  return (
    <Flex alignItems="center" gap={1}>
      <WarningFill18Icon />
      <Text variant="sm" fontWeight="bold">
        {information.type.label}
      </Text>
    </Flex>
  );
};
